import { useState, useEffect } from "react";
import { Grid, InputLabel } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import Match from "../Match/Match";

import CodeMirror from '@uiw/react-codemirror';
import { sql } from '@codemirror/lang-sql';
import { EditorView } from '@codemirror/view';

const FormSQLEditor = (props) => {
    const schemas = useSelector(state => state.schemas);

    return (
        <Grid item xs={12} sx={{ fontSize: '12px', '& .cm-editor': { border: '1px solid #eee', borderRadius: '4px' } }}>
            <InputLabel shrink>Query</InputLabel>
            <CodeMirror
                value={props.query}
                theme="light"
                minHeight="200px"
                basicSetup={{
                    foldGutter: true
                }}
                extensions={[sql(), EditorView.lineWrapping]}
                onChange={value => {
                    props.handler({ target: { name: 'query', value: value } })
                }}
            />
        </Grid>
    )
}
export default FormSQLEditor;